import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Button } from '@mui/material';
import { memo } from 'react';
import * as SX from './sx';
import type { AddMoreFilterProps as Props } from './types';

export const AddMoreFilter = memo(({ className, onClick, disabled }: Props) => {
  return (
    <Box
      className={classnames('AddMoreFilter', className)}
      display="flex"
      justifyContent="center"
      width="100%"
      sx={SX.root}
    >
      <Button
        onClick={onClick}
        color="primary"
        variant="text"
        fullWidth
        startIcon={<Icon name="plus" size={20} />}
        disabled={disabled}
        size="small"
      >
        Add Department
      </Button>
    </Box>
  );
});

AddMoreFilter.displayName = 'AddMoreFilter';
